import { render, staticRenderFns } from "./ShelfBadge.vue?vue&type=template&id=073d46f0&scoped=true&"
import script from "./ShelfBadge.vue?vue&type=script&lang=js&"
export * from "./ShelfBadge.vue?vue&type=script&lang=js&"
import style0 from "./ShelfBadge.vue?vue&type=style&index=0&id=073d46f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d46f0",
  null
  
)

export default component.exports